export default "__VITE_ASSET__GzbyBees__"